export default {
    'post': {
        'title': "Title",
        'description': "Description"
    },
    'recentSearch': {
        'title': '最近の検索',
    },
    'searchResult': {
        'definition': 'できたらチェックしてね！',
        'howTo': 'やり方・伝え方',
        'media': '関連する情報',
        'results': '件'
    }
};
